<template>
  <div class="item-con" :class="{ 'large-font-mode': pageData.largeFontMode }">
    <div class="label-con flex flex-row align-center" @click="toggleExpand">
      <div class="icon" />
      <div class="label">扩展</div>
      <div class="expand-icon">
        <i :class="isExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" />
      </div>
    </div>
    <div v-show="isExpanded" class="content">
      <div class="flex flex-row">
        <el-form label-width="80px" size="small" inline :disabled="['2','3','4'].indexOf( pageData.activeDiagRecord.diagRecord.stateSign)>-1">
          <el-row>
            <el-col :span="12">
              <el-form-item label="既往史" class="treatment-form-item">
                <key-word
                  v-model="pageData.activeDiagRecord.treatmentRecord.hisContent"
                  code="his"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="家族史" class="treatment-form-item">
                <key-word
                  v-model="pageData.activeDiagRecord.treatmentRecord.familyContent"
                  code="family"
                  :label-width="180"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="四诊" class="treatment-form-item">
                <key-word
                  id="key4"
                  v-model="pageData.activeDiagRecord.treatmentRecord.fdmContent"
                  code="fdm"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="体质" class="treatment-form-item">
                <key-word
                  v-model="pageData.activeDiagRecord.treatmentRecord.phyContent"
                  code="phy"
                  :label-width="180"
                />
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="治法" class="treatment-form-item">
                <key-word
                  v-model="pageData.activeDiagRecord.treatmentRecord.chTherapyContent"
                  code="chTherapy"
                />
              </el-form-item>
            </el-col>
            <!-- 新增：体征 -->
            <el-col :span="12">
              <el-form-item label="体征" class="treatment-form-item">
                <el-input
                  v-model="pageData.activeDiagRecord.treatmentRecord.signs"
                  placeholder="请输入体征"
                  class="el-input"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="血压低值" class="treatment-form-item">
                <el-input-number
                  v-model="pageData.activeDiagRecord.treatmentRecord.lowPressure"
                  :precision="2"
                  class="el-input"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="血压高值" class="treatment-form-item">
                <el-input-number
                  v-model="pageData.activeDiagRecord.treatmentRecord.highPressure"
                  :precision="2"
                  class="el-input"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="血糖" class="treatment-form-item">
                <el-input-number
                  v-model="pageData.activeDiagRecord.treatmentRecord.bloodSugar"
                  :precision="2"
                  class="el-input"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="体温" class="treatment-form-item">
                <el-input-number
                  v-model="pageData.activeDiagRecord.treatmentRecord.temperature"
                  :precision="2"
                  class="el-input"
                />
              </el-form-item>
            </el-col>
            <!-- 新增：脉搏 -->
            <el-col :span="12">
              <el-form-item label="脉搏" class="treatment-form-item">
                <el-input-number
                  v-model="pageData.activeDiagRecord.treatmentRecord.pulse"
                  :precision="0"
                  :min="0"
                  placeholder="次/分"
                  class="el-input"
                />
              </el-form-item>
            </el-col>
            <!-- 新增：呼吸 -->
            <el-col :span="12">
              <el-form-item label="呼吸" class="treatment-form-item">
                <el-input-number
                  v-model="pageData.activeDiagRecord.treatmentRecord.breathe"
                  :precision="0"
                  :min="0"
                  placeholder="次/分"
                  class="el-input"
                />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import KeyWord from "@/views/business/page/treatment/KeyWord.vue"

export default {
  components: {
    KeyWord
  },
  inject: ["pageData"],
  data() {
    return {
      isExpanded: false // 默认收起状态
    }
  },
  methods: {
    toggleExpand() {
      this.isExpanded = !this.isExpanded
    }
  }
}
</script>

<style scoped lang="scss">
/* 大字模式样式 */
.large-font-mode {
  font-size: 1.2em;

  .label-con {
    .label {
      font-size: 18px;
      line-height: 28px;
    }
  }

  .el-form-item {
    margin-bottom: 10px;

    ::v-deep .el-form-item__label {
      font-size: 15px;
      line-height: 32px;
    }

    ::v-deep .el-input__inner,
    ::v-deep .el-input-number .el-input__inner {
      font-size: 15px;
      height: 36px;
      line-height: 36px;
    }

    ::v-deep .el-input-number {
      line-height: 34px;
    }
  }

  .el-col {
    margin-bottom: 8px;
  }
}
.item-con {
  .label-con {
    margin-bottom: 12px;
    cursor: pointer; // 添加手型指针表示可点击
    .icon {
      width: 4px;
      height: 14px;
      background: #165DFF;
      border-radius: 0 0 0 0;
      margin-right: 8px;
    }

    .label {
      font-family: PingFang SC, PingFang SC, serif;
      font-weight: bold;
      font-size: 16px;
      color: #1D2129;
      line-height: 24px;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }

    .expand-icon {
      margin-left: 8px;
      color: #165DFF;
      transition: transform 0.3s;
    }
  }
}

.treatment-form-item {
  // max-width: 800px;
  margin-bottom: 5px;

  // .el-input {
  //   // width: 280px;
  // }
}
</style>
